import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
interface ServiceHeroProps {
  badge: string;
  title: string;
  subtitle: string;
  imageUrl: string;
}
export function ServiceHero({
  badge,
  title,
  subtitle,
  imageUrl
}: ServiceHeroProps) {
  return <section className="relative w-full pt-32 pb-24 lg:pt-40 lg:pb-32 flex items-center justify-center overflow-hidden" data-id="element-487" data-mp="2rof05ojcc7e2">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-488" data-mp="3fgc834jo6f9w">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover" aria-hidden="true" data-id="element-489" data-mp="3kdvoob3ub450" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/40" data-id="element-490" data-mp="35o693av02xl7" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-491" data-mp="27pn82xs7xha">
        <FadeIn direction="up" delay={0.05} data-id="element-492" data-mp="25we8gzp5164">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-full mb-6 border border-white/30 shadow-sm" data-id="element-493" data-mp="6ypmheudirmy">
            <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-494" data-mp="h320zr3m84vu" />
            {badge}
          </div>
        </FadeIn>
        <FadeIn direction="up" delay={0.15} data-id="element-495" data-mp="vshomy7unu7b">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6 drop-shadow-lg" data-id="element-496" data-mp="vtixqx5b26me">
            {title}
          </h1>
        </FadeIn>
        <FadeIn direction="up" delay={0.25} data-id="element-497" data-mp="14qjk6y8tdun7">
          <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed drop-shadow-md font-medium" data-id="element-498" data-mp="zt1j1u11gjpr">
            {subtitle}
          </p>
        </FadeIn>
      </div>
    </section>;
}